import $ from "jquery";

require('bootstrap-select');
require('moment');
const colorsHex = [
    '#FB9A99',
    '#C8C8FF',
    '#A6CEE3',
    '#64BB88',
    '#FFD384',
    '#1F78B4',
    '#d083ec',
    '#D60B0B',
    '#3edaef',
    '#733eef',
    '#ef913e'
];

const sel = $("#user").clone();
sel.attr('id', 'userSelect');
sel.appendTo("#cloneUser");

const colorsCss = [
    'color-red',
    'color-lylac',
    'color-blue',
    'color-green',
    'color-yellow',
    'color-dark-blue',
    'color-purple',
    'color-dark-red',
    'color-aqua',
    'color-blue-magenta',
    'color-orange'
];
let initChartData = {};

const renderCounters = (data) => {
    $('#counters').html('');
    $.each(data, function (name, val) {
        $('#counters').append(
            `<div class="col border rounded text-center mx-3">
                <span class="font-weight-bold lylac">${val}</span>
                <span class="name">${name}</span>
            </div>`
        );
    });
}

const drawAxisTickColors = (dataChart) => {
    let data = new google.visualization.DataTable();
    let bookNumberInfo = [];
    dataChart.labels.forEach((day, k) => {
        bookNumberInfo.push([moment(day).format('DD.MM.YYYY')]);
    })
    let sumTotal = [];
    data.addColumn('string', 'Date');
    dataChart.datasets.forEach((drawData, i) => {
        data.addColumn('number', drawData.label);
        sumTotal.push(drawData.data.reduce((a, b) => a + b, 0));
        dataChart.labels.forEach((day, k) => {
            bookNumberInfo[k].push(drawData.data[k]);
        })
    })
    data.addRows(bookNumberInfo);

    var options = {
        chart: {
            title: 'Box Office Earnings in First Two Weeks of Opening',
            subtitle: 'in millions of dollars (USD)'
        },
        height: 550,
        legend: 'none',
        responsive: true,
        colors: colorsHex,
        curveType: 'function',
        hAxis: {
            title: 'Дні',
            textStyle: {
                color: '#000',
                fontSize: 12,
                fontName: 'Roboto',
                bold: true,
                italic: true
            },
            titleTextStyle: {
                color: '#000',
                fontSize: 16,
                fontName: 'Roboto',
                bold: true,
                italic: false
            }
        },
        vAxis: {
            title: 'Книжки',
            textStyle: {
                color: '#000',
                fontSize: 12,
                fontName: 'Roboto',
                bold: true,
                italic: true
            },
            titleTextStyle: {
                color: '#000',
                fontSize: 16,
                fontName: 'Roboto',
                bold: true,
                italic: false
            }
        },
        axes: {
            x: {
                0: {side: 'top'},
            }
        }
    };

    $('#lineChartSelectors').html('')
    dataChart.datasets.forEach((drawData, i) => {
        $('#lineChartSelectors').append(
            `<div>
                <span class="chart-counter" id="chartCounterSwitch_${i}">${sumTotal[i]}</span>
                <div class="custom-control custom-switch ${colorsCss[i]}">
                    <input type="checkbox" class="custom-control-input" id="chartSwitch_${i}" checked>
                    <label class="custom-control-label" for="chartSwitch_${i}">${drawData.label}</label>
                </div>
            </div>`
        );
        $(`#chartSwitch_${i}`).click(function (e) {
            // need to check all switcher to hide unchecked
            const view = new google.visualization.DataView(data);
            let newColorOptions = [];
            $("input[id*='chartSwitch_']").each(function (index) {
                if (!$(this).prop('checked')) {
                    view.hideColumns([(index + 1)]);
                } else {
                    newColorOptions.push(colorsHex[index]);
                }

            });
            options.colors = newColorOptions;
            chart.draw(view, options);
        })
    })
    var chart = new google.visualization.LineChart(document.getElementById('test'));
    chart.draw(data, options);
}

const drawChart = (dataChart) => {
    Object.keys(dataChart.charts.pie_charts).forEach((key, i) => {
        $(`#piechart${i}`).html('');
        // let pieData = [];
        // pieData.push(['Task', 'Activity']);
        // Object.keys(dataChart.data.pie_charts[key]).forEach(_pKey => {
        //     pieData.push([_pKey, parseFloat(dataChart.data.pie_charts[key][_pKey])]);
        // });
        let pieData = dataChart.data.pie_charts[key];
        pieData.unshift(['Task', 'Activity']);

        if (pieData.length > 1) {
            var data = new google.visualization.arrayToDataTable(pieData);
            var options = {
                title: dataChart.charts.pie_charts[key],
                titleTextStyle: {
                    color: '#000',
                    fontSize: 16,
                    fontName: 'Roboto',
                    bold: true,
                    italic: false
                },
                legend: {
                    textStyle: {
                        color: '#000',
                        fontSize: 12,
                        fontName: 'Roboto',
                        bold: false,
                        italic: false
                    }
                },
                chartArea: {
                    //left:20,
                    //top:20,
                    width: '85%',
                    height: '75%'
                },
                pieStartAngle: 30,
            };
            var chart = new google.visualization.PieChart(document.getElementById(`piechart${i}`));
            chart.draw(data, options);
        } else {
            pieData.push(['Данні відсутні', 1])
            var data = new google.visualization.arrayToDataTable(pieData);
            var options = {
                title: dataChart.charts.pie_charts[key],
                titleTextStyle: {
                    color: '#000',
                    fontSize: 16,
                    fontName: 'Roboto',
                    bold: true,
                    italic: false
                },
                legend: {
                    textStyle: {
                        color: '#000',
                        fontSize: 12,
                        fontName: 'Roboto',
                        bold: false,
                        italic: false
                    }
                },
                chartArea: {
                    //left:20,
                    //top:20,
                    width: '85%',
                    height: '75%'
                },
                colors: ['#565555'],
                enableInteractivity: false,
                pieSliceText: 'none',
                tooltip: {
                    trigger: 'none'
                }
            };
            var chart = new google.visualization.PieChart(document.getElementById(`piechart${i}`));
            chart.draw(data, options);
        }
    });
}

export default {
    el: '#reportsCharts',
    data: {
        chartDatas: {}
    },
    watch: {
        chartDatas: function (newChartDatas, oldChartDatas) {
            const self = this;
            const chartLoader = document.createElement('script')
            chartLoader.setAttribute('src', 'https://www.gstatic.com/charts/loader.js')
            document.head.appendChild(chartLoader);
            chartLoader.onload = () => {
                const rangeSettings = {
                    locale: {
                        format: "DD.MM.YYYY",
                        separator: " - ",
                        applyLabel: "Прийняти",
                        cancelLabel: "Відмінити",
                        fromLabel: "Від",
                        toLabel: "До",
                        customRangeLabel: "Custom",
                        weekLabel: "W",
                        daysOfWeek: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
                        monthNames: [
                            "Січень",
                            "Лютий",
                            "Березень",
                            "Квітень",
                            "Травень",
                            "Червень",
                            "Липень",
                            "Серпень",
                            "Вересень",
                            "Жовтень",
                            "Листопад",
                            "Грудень",
                        ],
                        firstDay: 1,
                    },
                };

                const renderData = () => {
                    self.getA().then((res) => {
                        renderCounters(res.data.data.counters);
                        drawAxisTickColors(res.data.data.actions);
                        drawChart(res.data);
                    })
                }

                /* Filters */
                $('#chartDateRange').daterangepicker(rangeSettings, function (begin, end) {
                    document.getElementsByClassName('period-title')[0].querySelector('em').textContent =
                        `${moment(begin).format('DD.MM.YYYY')} - ${moment(end).format('DD.MM.YYYY')}`
                    document.getElementById('dateBegin').value = moment(begin).format('DD.MM.YYYY');
                    document.getElementById('dateEnd').value = moment(end).format('DD.MM.YYYY');
                    // get info about period
                    renderData()
                });
                $("#library").change(function () {
                    $('#user').val('');
                    const libraryId = $('#library').val();
                    const optgroups = $('#user').children();
                    $('#cloneUser').html('');
                    if (libraryId) {
                        const select = $("<select></select>").attr("id", "userSelect").attr("name", "userSelect");
                        $.each(optgroups, function (index) {
                            if ($(this).attr('data-library-id') == libraryId) {
                                select.append('<option value="">Всі працівники</option>');
                                select.append($(this).html());
                            }
                        });
                        select.appendTo("#cloneUser");
                        select.selectpicker();
                    } else {
                        sel.appendTo("#cloneUser");
                        sel.selectpicker();
                    }
                    renderData();
                    $('#userSelect').change(function () {
                        renderData();
                    });
                });
                google.charts.load('current', {packages: ['corechart', 'line']});
                google.charts.setOnLoadCallback(function () {
                    drawAxisTickColors(newChartDatas.data.actions)
                })
                google.charts.setOnLoadCallback(function () {
                    drawChart(newChartDatas)
                })
            }
        }
    },
    mounted() {
        $('#reportsCharts').removeClass('disabled-content');
        $('#userSelect').selectpicker();
    },
    methods: {
        getA() {
            return axios.get(`/library/reports/general/get_data`, {
                params: {
                    begin: $('#dateBegin').val(),
                    end: $('#dateEnd').val(),
                    user_id: $('#userSelect').val(),
                    library_id: $('#library').val()
                }
            });
        },
    },
    beforeMount() {
        this.getA().then((resp) => {
            renderCounters(resp.data.data.counters);
            initChartData = resp.data;
            this.chartDatas = resp.data;
        })
    },
}
